/* 
9  - tab
13 - enter
16 - shift
27 - escape
32 - space
*/
$(function() {
        var $wrappers = $('.a11y-tooltip'),
        $texttooltipwrappers = $('.a11y-tooltip.text-tooltip'),
        $contents = $('.a11y-tooltip span:first-of-type'),
        tooltipLabel = 'more information tooltip',
        target = false,
        tooltip = false,
        title = false,
        userIsTouching = false,
        tooltipArrowPosition,
        targetLeftPostion,
        containerSpace,
        $targets,
        domTarget,
        ttClose = null;

		$wrappers.prepend('<a aria-label="'+ tooltipLabel +'" aria-expanded="false" href="#"></a>');
		$targets = $('.a11y-tooltip a:first-of-type');
		$contents.attr('aria-hidden','true');
		$texttooltipwrappers.each(function(){
			$(this).find('a:first-of-type').text($(this).attr('data-text'));
		})
		
		//console.log($targets)

    $targets.on('touchstart', function(e) {
        //console.log('touchstart',e.type);
				userIsTouching = true;
    });
    
    $targets.on('mouseenter', function(e) {
        //console.log('mouseenter',e.type);
				if(!userIsTouching){// touch screens pass mouseenter event after touchstart, we don't want this, we want click
	       	tooltipOpen(e)
	      }
    });
    
    $targets.on('mouseleave', function(e) {
    		//console.log('mouseleave',e.type);
        if(!userIsTouching){// touch screens pass mouseenter event after touchstart, we don't want this, we want click
	       	tooltipClose(e)
	      }
    });	

    $targets.on('click', function(e) {
       	//console.log('click',e.type)
        if(!$('#tooltip').length) {
        		tooltipOpen(e);
        } else{
        		tooltipClose(e);
        }
    });

    $targets.on('keyup', function(e) {
        if ($('#tooltip').length && (e.keyCode == 27 || (e.keyCode == 9 && e.shiftKey) || e.keyCode == 32)){
            tooltipClose(e);
        }else if(!$('#tooltip').length && e.keyCode == 32){
            tooltipOpen(e)
        }
    });
    $targets.on('keydown', function(e) {
        return !(e.keyCode == 32)
    });

    var tooltipOpen = function(e) {
        //console.log('tooltipOpen',e.type)
        e.stopPropagation();
        e.preventDefault();
        $("#tooltip").remove();
        target = $(e.target);
        domTarget = e.target;
        ttClose = null;
        
        tip = target.next().html();
        tooltip = $('<div id="tooltip"><span class="tooltip-arrow"></span><div class="tooltip-content"></div></div>');
        if (e.type === 'click') {
            ttClose = '<br /><button class="tooltip-close" aria-label="Close information tooltip">&times;</button>';
            tooltip.append(ttClose);
        }

        if (!tip || tip == '') {
            return false;
        }
        tooltip.find('.tooltip-content').html(tip);//.css('opacity', 0)

        $('body').after(tooltip);

        tooltipInit(tooltip);
    }

    var tooltipInit = function(tooltip) {
        //console.log('tooltipInit',target)
        target.attr('aria-expanded', 'true');
        
        var viewPortWidth = $(window).width(),
        		viewPortHeight = $(window).height(),
        		pos_left = target.offset().left + (target.outerWidth() / 2) - (tooltip.outerWidth() / 2),
        		pos_top = 0,
        		excessive_height = false,
        		scroll_left = window.scrollX || window.pageXOffset || document.body.scrollLeft + (document.documentElement && document.documentElement.scrollLeft || 0),
        		scroll_top = window.scrollY || window.pageYOffset || document.body.scrollTop + (document.documentElement && document.documentElement.scrollTop || 0),
        		target_left = parseInt(domTarget.getBoundingClientRect().left),
        		target_top = parseInt(domTarget.getBoundingClientRect().top),
        		addClass = '',
        		margin = viewPortWidth < 768 ? 15 : 20;

        // position box ABOVE trigger based on target position and bubble height
        if(target_top >= viewPortHeight/2){
        	// If tooltip bubble is too tall, try to widen the bubble until it fits without exceeding viewport width
        	while(tooltip.outerHeight() > target_top - 20 && tooltip.outerWidth() < viewPortWidth - 40){
	        	tooltip.width(tooltip.width()+10);
	        	//console.log(tooltip.outerWidth())
	        }
	        if(tooltip.outerHeight()> target_top - 20){
	        	excessive_height = true
	        }else{
	        	pos_top += (scroll_top + target_top - tooltip.outerHeight() - 6);
	        }  
        }
        // position box BELOW trigger based on target position and bubble height
        if(target_top < viewPortHeight/2 || excessive_height){
        	// If tooltip bubble is too tall, try to widen the bubble until it fits without exceeding viewport width
        	while(tooltip.outerHeight()+target_top + 40 > viewPortHeight+scroll_top && tooltip.outerWidth() < viewPortWidth - 40){
	        	tooltip.width(tooltip.width()+10);
	        }
        	pos_top += (scroll_top + target_top + 25);
        	addClass = 'arrow-top';
        }
        
        // position toward left or right of trigger based on screen position
        pos_left = target_left + 8 - tooltip.outerWidth()/2 ;
	    	if (tooltip.outerWidth() > (viewPortWidth - 40)) {
            pos_left = (viewPortWidth - tooltip.outerWidth())/2;
            //console.log('centered')
        }else if(pos_left < 20){
        	pos_left = 20;
        	//console.log('move right')
        }else if(pos_left + tooltip.outerWidth() > viewPortWidth - 20){
        	pos_left = viewPortWidth - 20 - tooltip.outerWidth();
        	//console.log('move left')
        }

        tooltip.css({
            left: pos_left,
            top: pos_top
        }).addClass(addClass)
			
        tooltipArrowPosition = target.offset().left - tooltip.offset().left + target.width()/2 - 7;        
        if(tooltipArrowPosition <= 2){
        	tooltipArrowPosition = target.width()/2 - 6;
        }

        tooltip.find('.tooltip-arrow').css('left', tooltipArrowPosition);

        
        
        var $tipContentSpan = target.next(),
        		$closeBut = $tipContentSpan.find('button.tooltip-close');
        
      	if(ttClose && !$closeBut.length){
      		$tipContentSpan.attr('aria-hidden',false).html($tipContentSpan.html()+ttClose);
      	}
        		
        $('.tooltip-close').off();
        $('.tooltip-close').on('click', function(e) {
		        tooltipClose(e);
        }) 
        $('.tooltip-close').on('focus', function(e) {	
        	$('.tooltip-close').addClass('pseudo-focus')
        	//console.log('tooltip-close focus',$('#tooltip .tooltip-close'))
        });
        $('.tooltip-close').on('blur', function(e) {
        	 tooltipClose(e)// removing close from blur may be necessary for screen reader if there are focusable elements in tooltip content
        	$('.tooltip-close').removeClass('pseudo-focus')
        	//console.log('tooltip-close blur',$('#tooltip .tooltip-close'))
        });
    };
    
    var tooltipClose = function(e) {
       	//console.log('tooltipClose',e.type)
        e.stopPropagation();
        e.preventDefault();
        
        $('.a11y-tooltip a:first-of-type').attr('aria-expanded', 'false');
        

				target = $(e.target);
        var activeTip = target.parents('.a11y-tooltip').find('a:first-of-type');
        
        if (e.type === 'click') {
            activeTip.focus();
        }
        $('.a11y-tooltip span:first-of-type').attr('aria-hidden',true);

        tooltip.remove();
        $('.tooltip-close').remove();
        
    };
});